import { request } from '../utils/axios-utils';

export const approveRequestFromUI = async (requestId, isShootable = null) => {
    const data = { requestId };
    if (isShootable !== null && isShootable !== undefined) {
        data.isShootable = isShootable;
    }
    return await request({
        method: 'post',
        url: '/requests/approveFromUI',
        data,
    });
};

export const rejectRequestFromUI = async (requestId, rejectionReason = '') => {
    return await request({
        method: 'post',
        url: '/requests/rejectFromUI',
        data: { requestId, rejectionReason },
    });
};

